import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import { itemStates } from './item-states';
import styles from './wish-list-item.module.scss';

const BadgeInner = ({ className, text }) => (
    <div
        className={`badge ${className} d-block w-100 text-wrap size-oslo ${styles.badge}`}>
        {text}
    </div>
);

export const Badge = ({ itemState }) => {
    const { t } = useTranslator();

    switch (itemState) {
        case itemStates.bidderAuctionRemoved:
            return (
                <BadgeInner
                    className="badge-dark"
                    text={t('myt_itemState_active_bidderAuctionRemoved')}
                />
            );
        case itemStates.bidderBidRemoved:
            return (
                <BadgeInner
                    className="badge-dark"
                    text={t('myt_itemState_active_bidderBidRemoved')}
                />
            );
        case itemStates.bidderEndedWon:
            return (
                <BadgeInner
                    className="badge-success"
                    text={t('myt_itemState_active_bidderEndedWon')}
                />
            );
        case itemStates.bidderEndedReservedPriceNotReached:
            return (
                <BadgeInner
                    className="badge-dark"
                    text={t(
                        'myt_itemState_active_bidderEndedReservedPriceNotReached'
                    )}
                />
            );
        case itemStates.bidderEndedNotWon:
            return (
                <BadgeInner
                    className="badge-dark"
                    text={t('myt_itemState_active_bidderEndedNotWon')}
                />
            );
        case itemStates.bidderActiveLeading:
            return (
                <BadgeInner
                    className="badge-success"
                    text={t('myt_itemState_active_bidderActiveLeading')}
                />
            );
        case itemStates.bidderActiveReservedPriceNotReached:
            return (
                <BadgeInner
                    className="badge-branded"
                    text={t(
                        'myt_itemState_active_bidderActiveReservedPriceNotReached'
                    )}
                />
            );
        case itemStates.bidderActiveOverbidden:
            return (
                <BadgeInner
                    className="badge-branded"
                    text={t('myt_itemState_active_bidderActiveOverbidden')}
                />
            );
        case itemStates.generalActive:
            return (
                <BadgeInner
                    className="badge-branded"
                    text={t('myt_itemState_active_generalActive')}
                />
            );
        case itemStates.shopItemActive:
            return (
                <BadgeInner
                    className="badge-branded"
                    text={t('myt_itemState_active_shopItemActive')}
                />
            );
        case itemStates.generalEnded:
            return (
                <BadgeInner
                    className="badge-dark"
                    text={t('myt_itemState_active_generalEnded')}
                />
            );
        case itemStates.shopItemEnded:
            return (
                <BadgeInner
                    className="badge-dark"
                    text={t('myt_itemState_active_shopItemEnded')}
                />
            );
        case itemStates.buyItNowEndedWon:
            return (
                <BadgeInner
                    className="badge-success"
                    text={t('myt_itemState_active_buyItNowEndedWon')}
                />
            );
        case itemStates.buyItNowEnded:
            return (
                <BadgeInner
                    className="badge-dark"
                    text={t('myt_itemState_active_buyItNowEnded')}
                />
            );
        case itemStates.buyItNowActive:
            return (
                <BadgeInner
                    className="badge-branded"
                    text={t('myt_itemState_active_buyItNowActive')}
                />
            );
        case itemStates.shopItemEndedWon:
            return (
                <BadgeInner
                    className="badge-success"
                    text={t('myt_itemState_active_shopItemEndedWon')}
                />
            );
        default:
            throw new Error('Unknown item state');
    }
};
